<template>
  <div ref="filters" id="filters" class="filters" :class="{ 'fixed': isFixedPos }">
    <button v-for="filter in filters" :key="filter" :class="{ 'active': selected === filter }"
            @click="selectFilter(filter)">
      {{ filter }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  data () {
    return {
      selected: this.filters[0],
      isFixedPos: false
    }
  },
  props: {
    filters: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    selectFilter (filter) {
      this.selected = filter
      this.$emit('activeFilter', this.selected)
    },
    handleScroll () {
      if (window.innerWidth >= 719) {
        this.isFixedPos = false
        return
      }
      const targetElement = document.getElementById('filters')
      if (!targetElement) return

      // Calculate position of the element
      const rect = targetElement.getBoundingClientRect()
      const scrollY = window.pageYOffset || document.documentElement.scrollTop

      // Check if element is above the current scroll position
      this.isFixedPos = scrollY >= rect.top

      // Android Fix: Reset isFixedPos to false if scrolled to the top
      if (scrollY === 0) {
        this.isFixedPos = false
      }
    }
  },
  mounted () {
    this.$emit('activeFilter', this.selected)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
